module.exports = __webpack_public_path__ + "static/media/boxing-1.0f1d3f9d.png";